// TOKENS

/*
  These base values are not to be used directly.
  Use a semantic exported name instead

  TODO: These are not yet in Figma. Must update when they are added.
  These values are based on styleComponents.transitionSpeed
  and added to as needed
*/

export const transition_slower_raw = 350

const transition_slowest = '1000ms'
export const transition_slower = `${transition_slower_raw}ms`
export const transition_slow = '200ms'
// const transition_medium = '150ms'
export const transition_fast = '100ms'
// const transition_fastest = '50ms'

/*
  SEMANTIC TRANSITION SPEEDS (use these!)
*/

export const processing_spinSpeed = transition_slowest
export const button_transitionSpeed = transition_slow
export const pill_transitionSpeed = transition_fast
/* Not in Figma yet */
export const modal_transitionSpeed = transition_slow
export const flyout_transitionSpeed = transition_slower
export const switch_transitionSpeed = transition_slow
export const progressBar_transitionSpeed = transition_slow
